import { render } from "./LoginAndSignupModal.vue?vue&type=template&id=128ff282"
import script from "./LoginAndSignupModal.vue?vue&type=script&lang=js"
export * from "./LoginAndSignupModal.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__